import { Component, effect, inject, InjectionToken, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { SuccessSnackBarComponent } from './success-snack-bar/success-snack-bar.component';
import { PartialSuccessSnackBarComponent } from './partial-success-snack-bar/partial-success-snack-bar.component';
import { AnalyticsService } from '@iot-platform/core';
import { TranslateService } from '@ngx-translate/core';
// TODO This dependency should be reviewed its cause an app crash (kercom webapp)
// import { PopupComponent, PopupModule } from '@iot-platform/iot-platform-ui';
import { PopupComponent } from '../../../iot-platform/iot-platform-ui/src/lib/components/popup/popup.component';
import { PopupModule } from '../../../iot-platform/iot-platform-ui/src/lib/components/popup/popup.module';
import { LoaderComponent } from './loader/loader.component';
import { NotificationService } from './notification.service';

export const DISABLE_ERROR_MESSAGES_AFTER_LOGOUT = new InjectionToken<boolean>('DISABLE_ERROR_MESSAGES_AFTER_LOGOUT');

@Component({
  imports: [LoaderComponent, MatSnackBarModule, MatDialogModule, PopupModule],
  selector: 'iot-platform-notification',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './notification.component.html'
})
export class NotificationComponent {
  private readonly disableErrorMessagesAfterLogout: boolean | null = inject(DISABLE_ERROR_MESSAGES_AFTER_LOGOUT, { optional: true });
  public readonly snackBar: MatSnackBar = inject(MatSnackBar);
  public readonly notificationService: NotificationService = inject(NotificationService);
  public readonly translateService: TranslateService = inject(TranslateService);
  public readonly dialog: MatDialog = inject(MatDialog);
  analytic: AnalyticsService = new AnalyticsService('display_error_popup');
  loader: Signal<boolean> = this.notificationService.loader;
  isLoggedOut = input(false, {
    transform: (value: boolean) => {
      if (this.disableErrorMessagesAfterLogout) {
        return value;
      }
      return null;
    }
  });

  displaySuccessEffect = effect(() => {
    const success = this.notificationService.success();
    if (success) {
      this.displaySuccess(success);
    }
  });

  displayErrorEffect = effect(() => {
    const error = this.notificationService.error();
    if (error) {
      this.displayError(error);
    }
  });

  displayPartialSuccessEffect = effect(() => {
    const data = this.notificationService.partialSuccess();
    if (data) {
      this.displayPartialSuccess(data.successMessage, data.failureMessage);
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  public openErrorPopup(value: string | { code: string; error: string } | any) {
    // eslint-disable-next-line no-prototype-builtins
    if (value.hasOwnProperty('type')) {
      try {
        this.analytic.logError(
          value.type,
          `${value.error.error.code} - ${value.error.error.error}`,
          `${value.type} : ${value.error.error.code} - ${value.error.error.error}`
        );
      } catch {
        //
      }
    }

    this.dialog.open(PopupComponent, {
      width: '500px',
      disableClose: true,
      data: { type: 'error', value }
    });
  }

  private displaySuccess(message: string, duration = 4000): void {
    this.snackBar.openFromComponent(SuccessSnackBarComponent, {
      data: { message: this.translateService.instant(message), duration },
      panelClass: ['iot-snack-success']
    });
  }

  private displayPartialSuccess(successMessage: string, failureMessage: string, duration = 0): void {
    this.snackBar.openFromComponent(PartialSuccessSnackBarComponent, {
      data: { successMessage, failureMessage, duration },
      panelClass: ['iot-snack-partial-success']
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  private displayError(error: string | { code: string; error: string } | any) {
    if (this.disableErrorMessagesAfterLogout) {
      if (this.isLoggedOut() === false) {
        this.openErrorPopup(error);
      }
    } else {
      this.openErrorPopup(error);
    }
  }
}
